export const STORAGE_KEY = 'company-creation-progress';
export const COMPANY_ID_STORAGE_KEY = 'company-creation-company-id';

export interface CompanyCreationProgress {
  step: number;
  companyId?: string;
}

export const loadProgress = (): CompanyCreationProgress | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const saveProgress = (progress: CompanyCreationProgress): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
    if (progress.companyId) {
      localStorage.setItem(COMPANY_ID_STORAGE_KEY, progress.companyId);
    }
  } catch {
    // Silent fail if localStorage is not available
  }
};

export const clearProgress = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(COMPANY_ID_STORAGE_KEY);
  } catch {
    // Silent fail if localStorage is not available
  }
};

